export const LayoutType = {
  Grid: 'grid',
  Table: 'table',
}

export const LayoutTypeDisplayName = {
  [LayoutType.Grid]: 'Grid view',
  [LayoutType.Table]: 'Table view',
}
